// Configures the generated OpenAPI client singleton.
// All requests made via the generated services will:
//   - target the backend at VITE_API_URL (fallback http://localhost:8000)
//   - include cookies so the HTTP-only auth cookies set by /auth/callback flow
import { OpenAPI } from './generated'
import { getApiBaseUrl } from './env'

OpenAPI.BASE = getApiBaseUrl()
OpenAPI.WITH_CREDENTIALS = true
OpenAPI.CREDENTIALS = 'include'

export { OpenAPI }
